import { useMemo, useCallback } from "react";
import { parseISO, startOfDay, isWithinInterval } from "date-fns";
import { useImportantDates } from "@/services/settings";

interface DoNotBookRange {
  start: Date;
  end: Date;
  title: string;
}

export function useDoNotBookDates() {
  const { data: importantDates = [] } = useImportantDates();

  const doNotBookRanges = useMemo<DoNotBookRange[]>(
    () =>
      importantDates
        .filter((d) => d.doNotBook && d.begin != null && d.end != null)
        .map((d) => ({
          start: startOfDay(parseISO(d.begin!)),
          end: startOfDay(parseISO(d.end!)),
          title: d.title,
        })),
    [importantDates]
  );

  const isDateBlocked = useCallback(
    (date: Date): boolean => {
      const day = startOfDay(date);
      return doNotBookRanges.some((range) =>
        isWithinInterval(day, { start: range.start, end: range.end })
      );
    },
    [doNotBookRanges]
  );

  const getBlockedReason = useCallback(
    (date: Date): string | undefined => {
      const day = startOfDay(date);
      const match = doNotBookRanges.find((range) =>
        isWithinInterval(day, { start: range.start, end: range.end })
      );
      return match?.title;
    },
    [doNotBookRanges]
  );

  return { isDateBlocked, getBlockedReason };
}
